/**
 * Salesforce record deep link via the API's /api/sf/link/:id frontdoor route
 * (same absolute-URL rule as MainTableTile: the API lives on api.* in prod).
 */
export function sfLink(id: string): string {
  const apiBase =
    typeof window !== 'undefined' && window.location.hostname.endsWith('salesdashboard.adeptia.org')
      ? `${window.location.protocol}//api.salesdashboard.adeptia.org`
      : '';
  return `${apiBase}/api/sf/link/${encodeURIComponent(id)}`;
}

/** Sales Effectiveness leaderboard (per-rep MAIN-04/01/19), for the CEO. */
export const SALES_EFFECTIVENESS_URL = 'https://claude.ai/artifact/2C1Yw3HBmNAvkt9Zpz99Vc';

/** FY2027 open-pipeline target — TEMPORARY (John 2026-11-04: "use a target of 3.5m for now"). */
export const FY2027_PIPELINE_TARGET = 3_500_000;
export const FY2027_PIPELINE_TARGET_NOTE = 'Temporary target ($3.5M) until the 2027 plan is final';

/** FY2026 year-end ARR forecast = FY2027 opening ARR (2027 plan model, 2026-10-07). */
export const YEAR_END_ARR_FORECAST = 14_900_000;
